<template>
    <div>
        <home-view v-if="!globalRefs.isLoggedIn"></home-view>
        <event-list-view v-if="globalRefs.isLoggedIn"></event-list-view>
    </div>
</template>

<script lang="ts" setup>
import { inject } from "vue";
import GlobalRefs from "@/GlobalRefs";

const globalRefs = inject<GlobalRefs>("globalRefs")!;
</script>
